import { useCallback } from "react";
import { useParams } from "react-router";

import useDebounceAsync from "hooks/useDebounceAsync";
import useSearchSpaceliftVcsFilesSuggestions from "shared/SpaceliftVcsRepo/useSearchSpaceliftVcsFilesSuggestions";
import { makeStringMatchesPredicate } from "utils/predicates";

type UseFileNameValidationProps = {
  currentFilePath?: string;
};

const useFileNameValidation = ({ currentFilePath }: UseFileNameValidationProps = {}) => {
  const { repoId } = useParams<{ repoId: string }>();

  const { refetch: checkFileExists } = useSearchSpaceliftVcsFilesSuggestions({
    repoId,
    skip: true,
  });

  const asyncValidate = useCallback(
    async (filePath: string): Promise<true | string> => {
      if (!filePath) return "File name is required";

      if (filePath === currentFilePath) return true;

      const response = await checkFileExists({
        repoID: repoId || "",
        commit: null,
        input: {
          fullTextSearch: null,
          predicates: [makeStringMatchesPredicate("filePath", [filePath])],
          fields: null,
        },
      });

      if (response.data.searchRepoFilesSuggestions.filteredCount > 0) {
        return "File already exists";
      }

      return true;
    },
    [currentFilePath, checkFileExists, repoId]
  );

  return useDebounceAsync(asyncValidate);
};

export default useFileNameValidation;
